/**
 * Preview mode banner
 * Shows at the top of the page when viewing draft content
 */
export default function PreviewBanner() {
  const isPreview = typeof window !== 'undefined' && sessionStorage.getItem('preview-mode') === 'true';

  if (!isPreview) return null;

  const exitPreview = () => {
    sessionStorage.removeItem('preview-mode');
    sessionStorage.removeItem('preview-documentId');
    sessionStorage.removeItem('preview-locale');
    window.location.reload();
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      backgroundColor: '#f59e0b',
      color: 'white',
      padding: '12px 16px',
      zIndex: 9999,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
        <strong>Preview Mode</strong>
        <span>You are viewing draft content from Strapi</span>
      </div>
      <button
        onClick={exitPreview}
        style={{
          backgroundColor: 'white',
          color: '#f59e0b',
          border: 'none',
          padding: '6px 16px',
          borderRadius: '4px',
          cursor: 'pointer',
          fontWeight: '600',
          fontSize: '14px'
        }}
      >
        Exit Preview
      </button>
    </div>
  );
}
